import React from 'react'
import { Link } from 'react-router-dom';

function TourCard(props) {
    const { tour } = props;

    // Handle image URL - if it's a full URL, use it as is, otherwise prepend assets path
    const getImageUrl = (image) => {
        if (!image) return '';
        if (image.startsWith('http://') || image.startsWith('https://')) {
            return image;
        }
        return `/assets/img/tour/${image}`;
    };

    const headline = (input) => {
        if (!input) return '';

        return input
            .trim()
            .replace(/[-_]+/g, ' ') // replace underscores and hyphens with spaces
            .replace(/\s+/g, ' ')   // collapse multiple spaces
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }
    return (
        <div className="tour-box th-ani">
            <div className="tour-box_img global-img">
                <img src={getImageUrl(tour?.thumbnail_image)} alt={tour?.title} />
            </div>
            <div className="tour-content">
                <h3 className="box-title">
                    <Link to={`/tours/${tour?.slug}`}>{tour?.title}</Link>
                </h3>
                <div className="tour-rating">
                    <div
                        className="star-rating"
                        role="img"
                        aria-label="Rated 5.00 out of 5"
                    >
                        <span style={{ width: "100%" }}>
                            Rated
                            <strong className="rating">5.00</strong> out of 5
                            based on <span className="rating">4.8</span>(4.8
                            Rating)
                        </span>
                    </div>
                    <Link
                        to={`/tours/${tour?.slug}`}
                        className="woocommerce-review-link"
                    >
                        (<span className="count">{tour?.rating ? headline(tour?.rating) : ''}</span>)
                    </Link>
                </div>
                <h4 className="tour-box_price">
                    <span className="currency">{tour?.price ? tour?.price : ''}</span>{tour?.price ? '/Person' : ''}
                </h4>
                <div className="tour-action">
                    {tour?.duration && (
                        <span>
                            <i className="fa-light fa-clock" />{tour?.duration ? tour?.duration : ''} Days
                        </span>
                    )}
                    <Link to={`/tours/${tour?.slug}`} className="th-btn style4">
                        Detail View
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default TourCard
